var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.75 15.285H26.415C22.86 15.285 19.965 12.39 19.965 8.835V4.5C19.965 3.675 19.29 3 18.465 3H12.105C7.485 3 3.75 6 3.75 11.355V24.645C3.75 30 7.485 33 12.105 33H23.895C28.515 33 32.25 30 32.25 24.645V16.785C32.25 15.96 31.575 15.285 30.75 15.285Z",
    fill: "#0044C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6995 3.31499C23.0845 2.69999 22.0195 3.11999 22.0195 3.97499V9.20999C22.0195 11.4 23.8795 13.215 26.1445 13.215C27.5695 13.23 29.5495 13.23 31.2445 13.23C32.0995 13.23 32.5495 12.225 31.9495 11.625C29.7895 9.44999 25.9195 5.53499 23.6995 3.31499Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.625H11.25C10.635 20.625 10.125 20.115 10.125 19.5C10.125 18.885 10.635 18.375 11.25 18.375H20.25C20.865 18.375 21.375 18.885 21.375 19.5C21.375 20.115 20.865 20.625 20.25 20.625Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 26.625H11.25C10.635 26.625 10.125 26.115 10.125 25.5C10.125 24.885 10.635 24.375 11.25 24.375H17.25C17.865 24.375 18.375 24.885 18.375 25.5C18.375 26.115 17.865 26.625 17.25 26.625Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.c16f24e81f287c1072fdf10807c1641b.svg";
export { ForwardRef as ReactComponent };